/*
* Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
* This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
* The receipt or possession of this program does not convey any rights to use, reproduce or disclose
* its contents in whole or in part, without the specific written consent of Inovalon, Inc.
* Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
* is a violation of the copyright laws and may subject you to criminal prosecution.
*/
import React from 'react'
import { CInsuranceSubHeader } from '../CInsuranceSubHeader/CInsuranceSubHeader'
import { ICoverageDiscoveryResponseStateManager, IInpatientTypeInsurance } from '../../../../services/CoverageDiscoveryResponseStateManager/contracts'
import { BenefitDetailsComponent } from '../BenefitDetails/BenefitDetails'

export interface IInsuranceBenefitsProps {
	data: IInpatientTypeInsurance
	CoverageDiscoveryResponseStateManager: ICoverageDiscoveryResponseStateManager
}

export class InsuranceBenefitsComponent extends React.Component<IInsuranceBenefitsProps> {
	render(): React.ReactNode {
		let checkCode = ''
		let isElementDisplayHeader = false
		const header = <CInsuranceSubHeader data={this.props.data} />
		const model = this.props.data.cInsuranceBenefits
		if (model && model.length > 0) {
			const insuranceDetails = model.map((benefit, index) => {
				const benefitDetailsModel = benefit.lines
				if (benefitDetailsModel && benefitDetailsModel.length > 0) {
					const details = <BenefitDetailsComponent key={index} data={benefitDetailsModel} />
					isElementDisplayHeader = true
					if (details.props.data.length !== 0) {
						const isHeaderCodeExists = checkCode !== benefit.code
						checkCode = benefit.code
						return (
							details !== null && (
								<tr key={index}>
									<td>{isHeaderCodeExists ? benefit.description + ':' : ' '}</td>
									<td colSpan={3}> {details} </td>
								</tr>
							)
						)
					}
				}
				return null
			})
			return (
				isElementDisplayHeader && (
					<>
						{header}
						{insuranceDetails}
					</>
				)
			)
		} else {
			return header
		}
	}
}
